export default __webpack_public_path__ + "static/media/preview.dee2464a.png";